<ion-grid [ngClass]="(!!navService.isActiveChildNavRightPaneViewDisplayed)?'preview-active':'preview-inactive'">
  <ion-row>
    <ion-col class="medical-insight-page-left-pane omni-left-pane">
      <medical-insight-list></medical-insight-list>
    </ion-col>
    <ion-col class="medical-insight-page-right-pane omni-right-pane">
      <ion-nav #medicalinsightpagerightpane></ion-nav>
    </ion-col>
  </ion-row>
</ion-grid>